import React, { Component } from 'react';
import styled from 'styled-components';
import logo from './Logo.png';

const Container = styled.div`
  margin-top: 20px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px;
  padding-right: 40px;

`;

const Price = styled.div`
  margin-left: 10px;
  font-size: 24px;
  line-height: 24px;
  color: #2196F3;
`;

const Logo = styled.img``;

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  max-width: 504px;
  margin: 0px 10px;
  padding: 0px;
  margin-bottom: 26px;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
  min-width: 141px;
`;

const Property = styled.p`
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #A0B0B9;
`;

const Value = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: #4A4A4A;
`;

export interface Ticket {
  carrier: string[];
  price: number;
  segments: [
    {
      origin: string;
      destination: string;
      date: string;
      stops: string[];
      duration: number;
    },
    {
      origin: string;
      destination: string;
      date: string;
      stops: string[];
      duration: number;
      },
  ]
};

//e: Ticket

const Card = (props: Ticket) => {

  


  const timeToString = String(props.segments[0].duration / 60);
  const hoursTo = timeToString.split('.')[0];
  const minutesTo = (parseFloat(timeToString.slice(2)) * 60).toFixed(0);




  const timeFromString = String(props.segments[1].duration / 60);
  const hoursFrom = timeFromString.split('.')[0];
  const minutesFrom = (parseFloat(timeFromString.slice(2)) * 60).toFixed(0);



  


let stopsToInfo = ``;
let stopsTo = props.segments[0].stops.join(', ');
if(props.segments[0].stops.length === 0) {
  stopsToInfo = `${props.segments[0].stops.length} пересадок`;
} else if(props.segments[0].stops.length === 1) {
  stopsToInfo = `${props.segments[0].stops.length} пересадка`;
} else if (props.segments[0].stops.length === 2 || props.segments[0].stops.length === 3 || props.segments[0].stops.length === 4) {
  stopsToInfo = `${props.segments[0].stops.length} пересадки`;
} else {
  stopsToInfo = `${props.segments[0].stops.length} пересадoк`;
}
    
let stopsFromInfo = ``;
let stopsFrom = props.segments[1].stops.join(', ');
if(props.segments[1].stops.length === 0) {
  stopsFromInfo = `${props.segments[1].stops.length} пересадок`;
} else if(props.segments[1].stops.length === 1) {
  stopsFromInfo = `${props.segments[1].stops.length} пересадка`;
} else if (props.segments[1].stops.length === 2 || props.segments[1].stops.length === 3 || props.segments[1].stops.length === 4) {
  stopsFromInfo = `${props.segments[1].stops.length} пересадки`;
} else {
  stopsFromInfo = `${props.segments[1].stops.length} пересадoк`;
}

  return (
    <Container>
      <Header>
        <Price> { props.price }  </Price>
        <Logo width={110} height={'auto'} src={logo}></Logo>
      </Header>
      <List>
        <Details>
  <Property> { props.segments[0].origin } - { props.segments[0].destination } </Property>
          <Value> 10:45 – 08:00 </Value>
        </Details>

        <Details>
          <Property> В пути </Property>
          <Value> {hoursTo}ч {minutesTo}м </Value>
        </Details>

        <Details>
          <Property> { stopsToInfo }  </Property>
          <Value> { stopsTo } </Value>
        </Details>


        <Details>
          <Property> { props.segments[1].origin } - { props.segments[1].destination } </Property>
          <Value> 11:20 – 00:50 </Value>
        </Details>

        <Details>
          <Property> В пути </Property>
          <Value> {hoursFrom}ч {minutesFrom}м   </Value>
        </Details>

        <Details>
          <Property>  { stopsFromInfo } </Property>
          <Value> { stopsFrom }  </Value>
        </Details>
      </List>
    </Container>
  );
} 


export default Card
